module.exports = __webpack_public_path__ + "img/eo.06288070.svg";